import {GetExamsListParams} from 'domain/usecases/private/my-hospitalization/get-exams-list';
import {makeGetExamsList} from 'main/factories/usecases/private/my-hospitalization/get-exams-list-factory';

export const getExamsList = async (params: GetExamsListParams) => {
	try {
		const response = await makeGetExamsList().get(params);

		if (typeof response === 'string') {
			return {
				pages: 0,
				items: [],
			};
		}

		const pages = Math.ceil(response.totalElements / params.size);

		return {
			pages,
			items: response.content,
		};
	} catch (error) {
		throw new Error();
	}
};
